class PostService {
    contentAPIKey = config.contentAPIKey;
    loading = false;

    async fetch(page = 1, limit = 'all', skip = 0) {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.loading) return;

                this.loading = true;
                var self = this;

                $.ajax({
                    url: '/ghost/api/content/posts/',
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        key: this.contentAPIKey,
                        page: page,
                        limit: limit,
                        skip: skip
                    }

                })
                    .done(function (e) {
                        resolve(e)
                    })
                    .fail(function (e) {
                        reject(e)
                    })
                    .always(function () {
                        self.loading = false;
                    })

            } catch (e) {
                reject(e)
            }
        })
    }

    async fetchOne(id) {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.loading) return;

                this.loading = true;
                var self = this;

                $.ajax({
                    url: '/ghost/api/content/posts/' + id,
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        key: this.contentAPIKey,
                    }

                })
                    .done(function (e) {
                        resolve(e)
                    })
                    .fail(function (e) {
                        reject(e)
                    })
                    .always(function () {
                        self.loading = false;
                    })

            } catch (e) {
                reject(e)
            }
        })
    }

    async fetchImportantsByTag(tag, importantIndex = '1') {
        return new Promise(async (resolve, reject) => {
            try {
                $.ajax({
                    url: '/ghost/api/content/posts/',
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        key: this.contentAPIKey,
                        include: 'tags',
                        filter: 'tags:' + encodeURIComponent(tag) + '+tag:hash-p'+ importantIndex,
                        limit: 'all',
                    }

                })
                    .done(function (e) {
                        resolve(e)
                    })
                    .fail(function (e) {
                        reject(e)
                    })

            } catch (e) {
                reject(e)
            }
        })
    }

    async fetchByTag(tag, page = 1, limit = 'all', skip = 0) {
        return new Promise(async (resolve, reject) => {
            try {
                $.ajax({
                    url: '/ghost/api/content/posts/',
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        key: this.contentAPIKey,
                        include: 'tags',
                        filter: 'tags:' + encodeURIComponent(tag),
                        page,
                        limit: limit,
                        skip: skip
                    }

                })
                    .done(function (e) {
                        resolve(e)
                    })
                    .fail(function (e) {
                        reject(e)
                    })

            } catch (e) {
                reject(e)
            }
        })
    }

    async bFetchByTag(tag, page = 1, limit = 'all', skip = 0) {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.loading) return;

                this.loading = true;

                var arrayData = await Promise.all([
                    this.fetchByTag(tag, page, limit, skip),
                    // this.fetchImportantsByTag(tag, 1),
                    // this.fetchImportantsByTag(tag, 2),
                    // this.fetchImportantsByTag(tag, 3)
                ])

                this.loading = false;
                
                resolve(arrayData);

            } catch (e) {
                this.loading = false;
                reject(e)
            }
        })
    }
}